<template>
    <a-card :bordered="false" class="wjx-code">
      <div class="row">
        当前还剩<label class="num" :class="getClassStr">{{num}}</label>个随机码未绑定
      </div>
      <div class="row">
        随机码不够了？
        <a-button type="link" style="font-size: 20px" :loading="loading" @click="createCode">
          点击生成随机码
      </a-button>
        <a-input-number v-model="createNum" :min="1" :precision="0"  style="margin-left: 10px;width: 100px"  />
        （请勿重复点击）
      </div>
      <div class="row">
        <a-button type="link" style="font-size: 20px" :loading="loading" @click="exportCode">
          导出
        </a-button>
        <a-radio-group  v-model="exportType" >
          <a-radio-button value="">
            所有
          </a-radio-button>
          <a-radio-button value="0">
            未绑定
          </a-radio-button>
          <a-radio-button value="1">
            未导出
          </a-radio-button>
        </a-radio-group>
        随机码
      </div>
      <div  class="row">
            <div class="group-title info-row">
              选择随机码类型
            </div>
            <a-radio-group v-model="codeType" style="width: 80%" class="info-row">
              <a-row >
                <a-col :span="4">
                  <a-radio value="0">
                    基线期随机码
                  </a-radio>
                </a-col>
                <a-col :span="4">
                  <a-radio value="1">
                    随访期随机码
                  </a-radio>
                </a-col>
              </a-row>
            </a-radio-group>
          </div>
      <div class="row">
        <a-button type="link" style="font-size: 20px" :loading="loading" @click="clearCode">
          清空所有未绑定随机码
        </a-button>
      </div>
    </a-card>
</template>

<script>
  import { getAction,downloadFile } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME,statusData } from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'WjxCode',
    data(){
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) || '',
        num:0,
        loading:false,
        createNum:1000,
        exportType:'0',
        codeType:'3'
      }
    },
    mounted(){
      this.loadData()
    },
    computed:{
      getClassStr(){
        return this.num <100 ? 'warning':'normal'
      }
    },
    methods:{
      loadData(){
        getAction('/project/wjxCode/count',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.num = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      createCode(){
        if(this.codeType=='3'){
          this.$message.success("请选择随机码类型。")
          return
        }
        this.loading = true
        getAction('/project/wjxCode/createCode',{projectId:this.projectId,num:this.createNum,codeType:this.codeType}).then(res=>{
          if(res.success){
            this.loadData()
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      exportCode(){
        if(this.codeType=='3'){
          this.$message.success("请选择随机码类型。")
          return
        }
        downloadFile('/project/wjxCode/exportCode','随机码.xlsx',{exportType:this.exportType,projectId:this.projectId,codeType:this.codeType})
      },
      clearCode(){
        const that = this
        this.$confirm({
          title: '再次确认',
          content: '确认要清空所有未绑定随机码吗?',
          onOk() {
            that.loading = true
            getAction('/project/wjxCode/clearCode').then(res=>{
              if(res.success){
                that.loadData()
              }
            }).finally(()=>{
              that.loading = false
            })
          },
          onCancel() {
          },
        })

      }
    }
  }
</script>

<style scoped lang="less">
  .wjx-code{
    font-size: 20px;
    .row{
      margin-bottom: 30px;
      padding: 20px 100px;
    }
    .num{
      font-size: 32px;
    }
    .normal{
      color: green;
    }
    .ant-btn-link{
      padding: 0px;
    }
    .warning{
      color: red;
    }
  }
</style>